import { IconDefinition, library } from '@fortawesome/fontawesome-svg-core';
import {
    faEdit,
    faSpinner,
    faUserSecret,
    faTrash,
    faTimes,
    faSave,
    faCheck,
    faPlus,
    faCog,
    faGlobeAmericas
} from '@fortawesome/free-solid-svg-icons';

const icons: IconDefinition[] = [
    faEdit,
    faSpinner,
    faUserSecret,
    faTrash,
    faTimes,
    faSave,
    faCheck,
    faPlus,
    faCog,
    faGlobeAmericas
];

library.add(...icons);

